import { Routes, Route } from 'react-router-dom';
import EquipmentList from '../child_components/EquipmentList';
import EquipmentItems from '../child_components/EquipmentItems';

function SpecialEquipments() {
    

    return(
        <div className="p-4 mt-10">
            <Routes>
                <Route path='/items' element={ <EquipmentItems /> } />
                <Route path='/' element={ <EquipmentList /> } />
            </Routes>
        </div>
    )
}

export default SpecialEquipments;